import type RTKClient from "@cloudflare/realtimekit";
import type { RTKParticipant } from "@cloudflare/realtimekit";
import { RTK_HOST_PRESET } from "./realtimeKitPresets";

export function getStageFeedParticipants({
  meeting,
  includeSelf,
}: {
  meeting: RTKClient;
  includeSelf: boolean;
}): RTKParticipant[] {
  const selfId = meeting.self.id;

  const selfOnStage = meeting.stage.status === "ON_STAGE";

  const onStage = meeting.participants.joined.toArray().filter((participant) => {
    if (participant.id === selfId) {
      return includeSelf || participant.stageStatus === "ON_STAGE" || selfOnStage;
    }
    if (participant.stageStatus === "ON_STAGE") return true;
    if (!includeSelf && participant.presetName === RTK_HOST_PRESET) return true;
    return false;
  });

  if (
    (includeSelf || selfOnStage) &&
    !onStage.some((participant) => participant.id === selfId)
  ) {
    onStage.unshift(meeting.self as unknown as RTKParticipant);
  }

  return onStage.sort((a, b) => {
    if (a.id === selfId) return -1;
    if (b.id === selfId) return 1;
    if (a.presetName === RTK_HOST_PRESET && b.presetName !== RTK_HOST_PRESET) return -1;
    if (b.presetName === RTK_HOST_PRESET && a.presetName !== RTK_HOST_PRESET) return 1;
    return a.name.localeCompare(b.name);
  });
}

export function getVideoGridLayout({ count }: { count: number }): {
  cols: number;
  rows: number;
} {
  if (count <= 1) return { cols: 1, rows: 1 };
  return { cols: 1, rows: count };
}
